import i18next from 'i18next';

import { updateFinancierInstallersDocumentStatus } from 'common/api/financierAllianceInstaller';
import { PROCESS_STATUS } from 'common/constants';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    UPLOAD_DOCUMENT,
    UPLOAD_DOCUMENT_FAILURE,
    UPLOAD_DOCUMENT_SUCCESS,
} from '../actionTypes';
import { installerProfileActions } from '../reducer';
import * as selectors from '../selectors';

export default (document, file, onSuccess) => (dispatch, getState) => {
    const creditDocuments = selectors.getRequiredDocumentsListData(getState());
    const index = creditDocuments
        .map((creditDocument) => creditDocument.id)
        .indexOf(document.id);

    dispatch(installerProfileActions[UPLOAD_DOCUMENT]());

    updateFinancierInstallersDocumentStatus(document.id, {
        file,
        status: PROCESS_STATUS,
    })
        .then((response) => {
            dispatch(
                installerProfileActions[UPLOAD_DOCUMENT_SUCCESS]({
                    data: response.data.data,
                    index,
                }),
            );
            onSuccess();
            showToast({
                body: i18next.t('The file was uploaded successfully'),
            });
        })
        .catch((error) => {
            dispatch(
                installerProfileActions[UPLOAD_DOCUMENT_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
